import { RouterState } from "connected-react-router";
import { User } from "./Generated/User";

export enum SnackbarStatus {
    Closed = 0,
    Error = 1,
    Success = 2,
    Warning = 3,
    Info = 4
}

export enum ThemeTypes {
    Dark = 0,
    Light = 1,
}

export interface SnackbarState {
    status: SnackbarStatus;
    message: string;
    closeDelay: number;
}

export interface ReduxState {
    router: RouterState;
    currentUser: User;
    authenticated: boolean;
    snackbarState: SnackbarState;
    theme: ThemeTypes;
}

export enum SocketMessageType {
    None = 0,
    Heartbeat,
    PlayerJoin,
    PlayerLeave,
    RoomCreated,
    KickPlayer,
    JoinSpectators,
    JoinPlayers,
    SpectatePlayer,

    GameParametersChanged,
    StartGame,
    GameStarted,
    GameEnded,

    SubmitGuess,
    GuessFeedback,
    PlayerGuess,

    PowerupUsed,
    ResetPowerup
}

export enum LetterGuessState {
    Invalid = 0,
    CorrectLetter,
    Match
}

export interface GamePlayer {
    name: string;
    id: string;
    isHost: boolean;
    isSpectator: boolean;
    startedAsPlayer: boolean;
    isCurrent: boolean; // if this game player is the connecting player
}